/**
 * Textos de las cards del listado /servicios (diseño de referencia).
 * Se indexan por ID de servicio en BD para no depender de slugs rotos del CMS.
 */

const SERVICE_CARD_COPY_ES = {
  1: {
    title: "Recobro Amistoso",
    description:
      "Gestión amistosa paralela al proceso judicial para alcanzar acuerdos beneficiosos para todas las partes.",
  },
  2: {
    title: "Recobro Judicial",
    description:
      "Red de más de 400 letrados y procuradores que garantiza una actuación ágil y eficiente en todo el país.",
  },
  3: {
    title: "Defensa Jurídica",
    description:
      "Servicios especializados para entidades financieras: derecho al honor y protección frente a cláusulas abusivas.",
  },
  4: {
    title: "Servicios para Inversores",
    description:
      "Estrategias diseñadas para maximizar el retorno en activos y carteras de impagos.",
  },
  5: {
    title: "Back Office Jurídico",
    description:
      "Soporte administrativo y operativo: digitalización, seguimiento de casos y reportes para optimizar la gestión.",
  },
  7: {
    title: "Compra de Carteras NPL",
    description:
      "Solución ágil para deshacerse de activos morosos o distressed con total seguridad.",
  },
};

const SERVICE_CARD_COPY_EN = {
  1: {
    title: "Amicable Collection",
    description:
      "Friendly management parallel to the judicial process to reach agreements beneficial to all parties.",
  },
  2: {
    title: "Judicial Collection",
    description:
      "A network of more than 400 lawyers and court representatives ensuring agile and efficient action nationwide.",
  },
  3: {
    title: "Legal Defense",
    description:
      "Specialized services for financial institutions: right to honor and protection against abusive clauses.",
  },
  4: {
    title: "Investor Services",
    description: "Strategies designed to maximize returns on non-performing assets and portfolios.",
  },
  5: {
    title: "Legal Back Office",
    description:
      "Administrative and operational support: digitization, case tracking and reports to optimize management.",
  },
  7: {
    title: "NPL Portfolio Purchase",
    description:
      "An agile solution to dispose of delinquent or distressed assets with full security.",
  },
};

const COPY_BY_LANGUAGE = {
  1: SERVICE_CARD_COPY_ES,
  2: SERVICE_CARD_COPY_EN,
  es: SERVICE_CARD_COPY_ES,
  en: SERVICE_CARD_COPY_EN,
};

/**
 * Devuelve título y descripción de card según idioma e ID de servicio.
 * @param {number|string} languageId - ID de idioma (1=ES, 2=EN) o código 'es'/'en'.
 * @param {object} service - Registro del API con al menos `id`, `title`, `description`.
 * @returns {{ title: string, description: string }}
 */
export const getServiceCardCopy = (languageId, service) => {
  const langTable =
    COPY_BY_LANGUAGE[languageId] || COPY_BY_LANGUAGE[String(languageId)] || SERVICE_CARD_COPY_ES;

  const copy = langTable[String(service.id)];

  if (copy) {
    return copy;
  }

  const fallbackDescription = (service.description || "")
    .replace(/<[^>]*>/g, " ")
    .replace(/\s+/g, " ")
    .trim();

  return {
    title: service.title || "",
    description: fallbackDescription,
  };
};
